import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Box, ThemeProvider } from "@mui/material";
import { CssBaseline } from "@mui/material";
import Theme from "./themes/theme";

import Header from './components/Header'
import Footer from './components/Footer'

import Home from './pages/Home'
import Instore from './pages/Instore'
import Warehouse from './pages/Warehouse'
import Office from './pages/Office'
import Order from './pages/Order'
import Locations from './pages/Locations'
import Drinks from './pages/Drinks'
import ApplyStart from './pages/ApplyStart'
import About from './pages/About'
import Contact from './pages/Contact'
import Catering from './pages/Catering'
import Auth from './pages/Auth'
import Admin from './pages/Admin'

import { LocationsProvider } from './hooks/LocationContext'
import "./App.css"

const HEADER_HEIGHT = 100;

function AppContent() {
  const { pathname } = useLocation();
  const isHomepage = pathname === "/";

  return (
    <>
      <Header />
      <Box sx={{ pt: isHomepage ? 0 : `${HEADER_HEIGHT}px` }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="apply-online" element={<ApplyStart />} />
          <Route path="instore" element={<Instore />} />
          <Route path="warehouse" element={<Warehouse />} />
          <Route path="office" element={<Office />} />
          <Route path="order" element={<Order />} />
          <Route path="locations" element={<Locations />} />
          <Route path="drinks" element={<Drinks />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="catering" element={<Catering />} />
          <Route path="auth" element={<Auth />} />
          <Route path="auth/admin" element={<Admin />} />
          <Route
            path="webmail"
            Component={() => {
              window.location.href = "https://gator4026.hostgator.com:2096/";
              return null;
            }}
          />
        </Routes>
      </Box>
      <Footer />
    </>
  );
}

function App() {
  return (
    <LocationsProvider>
      <ThemeProvider theme={Theme}>
        <CssBaseline />
        <Router>
          <AppContent />
        </Router>
      </ThemeProvider>
    </LocationsProvider>
  );
}

export default App;